import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Filter2Icon(props: IconProps) {
    return <Icon {...props} iconKey={"filter_2"}/>
}
